import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { useAPI } from 'hooks/api/useAPI';
import APIError from 'types/api_error';

export function useLockPipeline(
  options: UseMutationOptions<void, APIError, { pipeline_id: string }> = {}
) {
  const { applicationID, client } = useAPI();

  return useMutation(
    ({ pipeline_id }) =>
      client.post(
        `/internal/apps/${applicationID}/pipelines/${pipeline_id}/lock`
      ),
    options
  );
}
